import LocationBlockedContent from './LocationBlockedContent';
export default LocationBlockedContent;
